import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Logo from "./Logo";
import { EASE } from "./Reveal";

const LINKS = [
    { label: "Layanan", href: "#layanan" },
    { label: "Portofolio", href: "#portofolio" },
    { label: "Proses", href: "#proses" },
    { label: "Kontak", href: "#kontak" },
];

export default function Navbar({ onNavigate }) {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (href) => {
        setOpen(false);
        setTimeout(() => onNavigate(href), open ? 250 : 0);
    };

    return (
        <>
            <header
                className={`fixed inset-x-0 top-0 z-[80] transition-[background-color,border-color] duration-500 ${
                    scrolled
                        ? "border-b border-white/10 bg-black/70 backdrop-blur-xl"
                        : "border-b border-transparent bg-transparent"
                }`}
            >
                <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 lg:px-10">
                    <a
                        href="#beranda"
                        data-testid="nav-logo-link"
                        onClick={(e) => {
                            e.preventDefault();
                            go("#beranda");
                        }}
                    >
                        <Logo />
                    </a>

                    <nav className="hidden items-center gap-9 lg:flex">
                        {LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`nav-link-${l.href.slice(1)}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    go(l.href);
                                }}
                                className="font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-300 transition-colors duration-300 hover:text-gold"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#kontak"
                            data-testid="nav-cta-button"
                            onClick={(e) => {
                                e.preventDefault();
                                go("#kontak");
                            }}
                            className="rounded-full bg-gold px-6 py-2.5 font-mono text-[11px] font-medium uppercase tracking-[0.18em] text-black transition-transform duration-300 hover:-translate-y-0.5 hover:bg-[#e5c14e]"
                        >
                            Mulai Konsultasi
                        </a>
                    </nav>

                    <button
                        data-testid="nav-menu-toggle"
                        aria-label="Buka menu"
                        onClick={() => setOpen((v) => !v)}
                        className="flex h-11 w-11 items-center justify-center border border-white/15 bg-black/40 backdrop-blur lg:hidden"
                    >
                        <div className="space-y-[5px]">
                            <span
                                className={`block h-px w-5 bg-white transition-transform duration-300 ${
                                    open ? "translate-y-[6px] rotate-45" : ""
                                }`}
                            />
                            <span
                                className={`block h-px w-5 bg-white transition-opacity duration-300 ${
                                    open ? "opacity-0" : ""
                                }`}
                            />
                            <span
                                className={`block h-px w-5 bg-white transition-transform duration-300 ${
                                    open ? "-translate-y-[6px] -rotate-45" : ""
                                }`}
                            />
                        </div>
                    </button>
                </div>
            </header>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="fixed inset-0 z-[75] flex flex-col justify-center bg-ink/95 px-8 backdrop-blur-xl lg:hidden"
                    >
                        <div className="space-y-2">
                            {LINKS.map((l, i) => (
                                <motion.a
                                    key={l.href}
                                    href={l.href}
                                    data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                                    initial={{ opacity: 0, x: -24 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ delay: 0.08 + i * 0.07, duration: 0.5, ease: EASE }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        go(l.href);
                                    }}
                                    className="block border-b border-white/10 py-5 font-serif text-4xl text-white"
                                >
                                    <span className="mr-4 font-mono text-xs text-gold">
                                        0{i + 1}
                                    </span>
                                    {l.label}
                                </motion.a>
                            ))}
                        </div>
                        <motion.a
                            href="#kontak"
                            data-testid="mobile-nav-cta"
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.4, duration: 0.5, ease: EASE }}
                            onClick={(e) => {
                                e.preventDefault();
                                go("#kontak");
                            }}
                            className="mt-10 rounded-full bg-gold py-4 text-center font-mono text-xs font-medium uppercase tracking-[0.2em] text-black"
                        >
                            Mulai Konsultasi
                        </motion.a>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}
